// @flow
import * as React from 'react'
import Button from 'ui/atoms/Button'
import Flex from 'ui/atoms/Flex'

type Props = {
  primaryAction?: boolean,
  secondaryAction?: boolean,
  primaryActionText?: string,
  secondaryActionText?: string,
  onPrimaryAction?: () => void,
  loading?: boolean,
  onSecondaryAction?: () => void,
  onHide?: () => void,
}

function ModalFooter({
  primaryAction,
  secondaryAction,
  primaryActionText,
  secondaryActionText,
  onPrimaryAction,
  onSecondaryAction,
  onHide,
  loading,
}: Props): React.Node {
  return (
    <Flex $horizontalSpacing="medium" justify="end">
      {secondaryAction && (onSecondaryAction || onHide) && (
        <Button onClick={onSecondaryAction || onHide}>
          {secondaryActionText}
        </Button>
      )}
      {primaryAction && onPrimaryAction && (
        <Button $primary loading={loading} onClick={onPrimaryAction}>
          {primaryActionText}
        </Button>
      )}
    </Flex>
  )
}

export default ModalFooter
